import {
    Component,
    Input,
    HostBinding,
    ViewEncapsulation,
    OnChanges,
    SimpleChanges,
    Output,
    EventEmitter
} from '@angular/core';

import { AuthService } from '../../core/upgraded-providers';

@Component({
    selector: 'app-power-level-tool',
    templateUrl: './level-tool.component.pug',
    styleUrls: ['./level-tool.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class LevelToolComponent implements OnChanges {

    @Input() powerLevel: number;
    public currentPowerLevel: number;

    @HostBinding('class.--warning') get isWarning(): boolean {
        return this.powerLevel > this.currentPowerLevel;
    }

    constructor(
        private _authService: AuthService,
    ) {
        this.currentPowerLevel = this._authService.Me.getPowerLevel();
    }

    ngOnChanges({ powerLevel }: SimpleChanges): void {
        if (powerLevel && powerLevel.firstChange) {
            return;
        }

        this.updatePowerLevel();
    }

    async updatePowerLevel() {
        await this._authService.check();
        this.currentPowerLevel = this._authService.Me.getPowerLevel();
    }

}
